__turbopack_context__.v({
  "adjustMarginContent": "adjustMarginModal-module-scss-module__jftfjW__adjustMarginContent",
  "symbol": "adjustMarginModal-module-scss-module__jftfjW__symbol",
  "symbolInfo": "adjustMarginModal-module-scss-module__jftfjW__symbolInfo",
});
